import React from "react";

const INeedToTwo = () => (
  <div>

	<h1>Uniqueness and Storage</h1>

  <p>HTML5 is the latest version of the markup language used by webpage browsers. 
    It was published in October 2014 by the World Wide Web Consortium(W3C). 
    One important provision of HTML5 is "local storage." As of HTML5, a 
    large amount of storage (~ 5 Mbytes) is available for webpages to store 
    information. Further, each webpage "origin" has its own local storage area. 
    An "origin" is the combination of the location of the webpage and the browser 
    used to display it.</p>

  <p>This means that the iNeed2 webpage and resources can be copied to any directory 
    on a computer, and each iNeed2 webpage in each of these directories will have 
    its own local storage area. This means that the iNeed2 webpage in the 
    "Add_Feature_One" directory can have its own ToDo list and the iNeed2 
    webpage in the "Add_Feature_Two" directory can have its own completely 
    independent ToDo list.</p>


	

  </div>
);

export default INeedToTwo;


// WEBPACK FOOTER //
// ./src/components/iNeed2_Slides/INeedToTwo.js